import React from 'react'
import { currentCampaign } from '../../content/campaigns'

export const CampaignContext = React.createContext(currentCampaign())
